import axios from "axios";
import {urlBoep, urlDocuentsId, urlEntity} from "./services.config";


export let getBoepList = function(){
    return new Promise( (resolve, reject) => {
        resolve(axios.get(urlBoep()));
    })
}

export let getDocumentsById = function(boepId: string){
    return new Promise( (resolve, reject) => {
        resolve(axios.get(urlDocuentsId(boepId)));
    })
}

export let getEntityById = function(entityId: string){
    return new Promise( (resolve, reject) => {
        resolve(axios.get(urlEntity(entityId)));
    })
}
